import BaseAPI from "@/apis/base/baseApi";
import httpClient from "@/apis/base/httpclient";
import { MSEnum } from '@/commons/enumeration'
class GroupAPI extends BaseAPI {
    constructor() {
        super();
    }

    apiName = "TaskGo";
    controllerName = "Groups";

    /**
       * Lấy danh sách nhóm
       * @param {*} payload
       * @returns
       */
    getListGroup(payload) {
        let request = {
            url: this.getAPIUrl() + '/list',
            data: payload
        };

        return httpClient.postAsync(request);
    }

    /**
       * Lấy danh sách nhóm
       * @param {*} payload
       * @returns
       */
    saveGroup(payload) {
        let request = {
            url: this.getAPIUrl(),
            data: payload
        };
        return httpClient.postAsync(request);
    }

    /**
       * Lấy thông tin nhóm người dùng
       * @param {*} id
       * @returns
       */
    getGroupByID(id) {
        let request = {
            url: this.getAPIUrl() + `/edit/${id}`
        }
        return httpClient.getAsync(request)
    }

    /**
       * Lấy danh sách nhóm
       * @param {*} payload
       * @returns
       */
    updateGroup(payload) {
        let request = {
            url: this.getAPIUrl(),
            data: payload
        };
        return httpClient.putAsync(request);
    }

    /**
     * submit danh sách dữ liệu
     * @param {*} payload
     * @returns
     */
    async multiSubmit(payload) {
        let request = {
            url: this.getAPIUrl() + "/submit",
            data: payload
        };

        return await httpClient.postAsync(request, true);
    }
    /**
       * Kiểm tra trùng tên nhóm
       * pqhieu(10/1/2023)
       */
    checkDuplicate(payload) {
        let request = {
            url: this.getAPIUrl() + "/check-duplicate",
            data: {
                ignores: [],
                model: payload,
                returnRecord: true,
            }
        };

        return httpClient.postAsync(request, true);
    }

    /**
       * Lấy danh sách nhóm
       * @param {*} payload
       * @returns
       */
    deleteGroup(id) {
        let request = {
            url: this.getAPIUrl() + "/delete",
            data: {
                GroupID: id
            }
        };
        return httpClient.deleteAsync(request);
    }
}

export default new GroupAPI();
